<template>
  <div>
    <div>
      <button class="v-btn card-animate-2" @click="preset = ''">Concierge</button>
      <button class="v-btn card-animate-2" @click="preset = 'search'">Price Search</button>
      <button class="v-btn card-animate-2" @click="preset = 'report'">Research</button>
    </div>
    <br />
    <transition name="fade" mode="out-in">
    <form v-if="preset === 'search'" class="inputarea" id="search-form" @submit.prevent="submitQuery">
      <div v-for="(site, index) in searchSites" :key="index" class="website-btn-container">
        <v-btn :color="selectedUrl === site.url ? 'primary' : 'default'" @click="selectUrl(site.url)">
          {{ site.name }}
        </v-btn>
      </div>
      <v-text-field v-model="searchItem" label="Enter the item to search"></v-text-field>
      <v-btn id="submitQuery" class="mx-2" type="submit" value="Submit">Submit</v-btn>
    </form>


      <form class="inputarea" v-if="preset === 'report'" id="report-form" @submit.prevent="submitQuery">
        <v-layout row wrap>
        <v-flex sm6 xs6 md4 lg4>
        <div class="chart-title-AI">Research Subject</div>
        <v-divider></v-divider>
        <v-text-field v-model="subject" label="Subject"></v-text-field>
        </v-flex>
        <v-flex sm6 xs6 md4 lg4>
          <div class="chart-title-AI">Report length</div>
        <v-divider></v-divider>
        <v-select 
          :items="['Synopsis (2-4 Sentences)', 'Short (1 Paragraph)', 'Medium (2 Paragraphs)', 'Long (4 to 6 Paragraphs)', 'Proposal (8 to 10 Paragraphs)', 'Detailed (As much as it can provide)']" 
          v-model="reportLength" 
          >
        </v-select>
        </v-flex>
        <v-flex sm6 xs6 md4 lg4>
        <div class="chart-title-AI">Site Search</div>
        <v-divider></v-divider>
        <v-text-field v-model="researchUrl" label="URL to browse"></v-text-field>
        </v-flex>
        <v-flex sm6 xs6 md12 lg12>
        <div class="chart-title-AI">Notes</div>
        <v-divider></v-divider>
        <v-textarea v-model="researchNotes" label="Research Notes"></v-textarea>
        </v-flex>
       
        </v-layout>
        <v-flex sm6 xs6 md4 lg6>
        <div v-for="(site, index) in presetSites" :key="index" class="website-btn-container">
          <v-btn outline class="v-btn" :color="researchWebsites.includes(site.url) ? 'primary' : 'default'" 
                 @click="toggleSite(site.url)">
            {{ site.name }}
          </v-btn>
        </div>
        </v-flex>
        <br />
        <!-- <v-text-field v-model="customSite" label="Other" @keyup.enter="addCustomSite"></v-text-field>
        <v-btn @click="addCustomSite">Add</v-btn> -->
        <!-- <v-title>References</v-title> -->
        <v-btn id="submitQuery" type="submit" value="Submit">Submit</v-btn>
      </form>
    </transition>
    <transition name="fade" mode="out-in">
    <form id="search-form" @submit.prevent="submitQuery" v-if="!preset">
      <div>
        <textarea
          onload="this.focus()"
          type="text"
          name="q"
          class="inputarea2 card-animate-2"
          placeholder="Describe your query here"
          v-model="queryPrompt"
          rows="4"
          cols="500"
          @keyup.enter="submitQuery"
        ></textarea>
      </div>
      <div>
        <v-btn class="mx-2 card-animate-2" type="submit" value="Submit">Submit</v-btn>
        <v-btn class="mx-2 card-animate-2" type="submit" value="Reset" @click="resetDialogue">Reset</v-btn>
        <v-btn v-if="editingQueryIndex !== -1" class="mx-2 card-animate-2" type="submit" value="Update" @click="updateQuery">Update</v-btn>
      </div>
      <br />

    </form>
  </transition>
    <div v-if="references.length">
    <h3>References:</h3>
    <ul>
      <li v-for="(ref, index) in sortedReferences" :key="index">{{ ref.url }} - {{ ref.importancePercentage }}%</li>
    </ul>
  </div>

      <!-- <div class="chart-title-AI">Research Results</div> -->
        <v-divider></v-divider>
    <div class="box" id="dialogueResults">
      <p v-for="(entry, index) in dialogueHistory" :key="index" v-html="entry"></p>
    </div>
    <br />
    
    <div v-if="loading" class="loading-container card-animate-2">
      <img class="mx-auto d-block" style="height: 25%; width: 25%" src="../assets/images/loading-spinner15.gif" alt="Loading" />
      <br />
      <p>{{ loadingText }}</p>
    </div>

    <div v-if="actionSteps.length">
      <p>Recommended Action Steps:</p>
      <ul>
        <li v-for="(step, index) in actionSteps" :key="index">{{ step }}</li>
      </ul>
    </div>
    <div>
      <v-btn class="mx-2 card-animate-2" @click="saveQuery">Save Query</v-btn>
    </div>
    <br />
    <saved-query-list
      :saved-queries="savedQueries"
      @edit-query="editSavedQuery"
      @delete-query="deleteSavedQuery"
    ></saved-query-list>
  <br />
  </div>
</template>
<script>
import submitAudio from '../assets/audio/input1.wav';
import codeCompleteAudio from "../assets/audio/SelectNew.wav";
import SavedQueryList from "./SavedQueryList.vue";
export default {
  components: {
    SavedQueryList,
  },
  data() {
    return {
      preset: '', // New data property to determine the selected preset
      // references: [
      //   { url: 'https://www.ebay.com', importancePercentage: 0.8 },
      //   { url: 'https://www.amazon.com', importancePercentage: 0.5 },
      //   { url: 'https://www.walmart.com', importancePercentage: 0.3 },
      // ],
      presetSites: [
        { name: 'Google', url: 'https://www.google.com' },
        { name: 'Bing', url: 'https://www.bing.com' },
        { name: 'Wikipedia', url: 'https://www.wikipedia.org' },
        //... add other preset sites here
      ],
      researchWebsites: [],
      customSite: '',
      searchSites: [
        { name: 'Ebay', url: 'https://www.ebay.com' },
        { name: 'Amazon', url: 'https://www.amazon.com' },
        { name: 'Walmart', url: 'https://www.walmart.com' },
        { name: 'Google', url: 'https://www.google.com' },
      ],
      customSearchSite: '',
      researchNotes: '',
      references: [],
      selectedUrl: '',
      searchItem: '',
      subject: '',
      researchUrl: '',
      reportLength: '',
      lastSavedQuery: "",
      lastSavedUrl: "",
      continuousMode: false,
      loading: false,
      loadingText: "",
      queryPrompt: "",
      dialogueHistory: [],
      actionSteps: [],
      currentActionIndex: 0,
      objectivesAchieved: false,
      savedQueries: [],
      editingQueryIndex: -1,
    };
  },
  mounted() {
    const storedsavedQueries = JSON.parse(localStorage.getItem("savedQueries"));
    if (storedsavedQueries) {
      this.savedQueries = storedsavedQueries;
    }

    this.codeEditor.on("change", () => {
      const code = this.codeEditor.getValue();
      document.getElementById("outputIframe").srcdoc = code;
    });
  },
  watch: {
    dialogueHistory() {
      const code = this.dialogueHistory
        .map(entry => entry.text.replace(/<\/?[^>]+(>|$)/g, ""))
        .join("\n");
      this.codeEditor.setValue(code, 1);
      document.getElementById("outputIframe").srcdoc = code;
    },
  },
  methods: {
    toggleSite(url) {
      const index = this.researchWebsites.indexOf(url);
      if (index === -1) this.researchWebsites.push(url);
      else this.researchWebsites.splice(index, 1);
    },
    addCustomSite() {
      if (this.customSite) {
        this.researchWebsites.push(this.customSite);
        this.customSite = ''; // Clear the input
      }
    },
    selectUrl(url) {
      this.selectedUrl = url;
    },
    addCustomSearchSite() {
      if (this.customSearchSite) {
        this.searchSites.push({ name: this.customSearchSite, url: this.customSearchSite });
        this.customSearchSite = ''; // Clear the input
      }
    },
    async submitQuery() {
      if (this.preset === 'search') {
        if (!this.selectedUrl || !this.searchItem) return;
        this.queryPrompt = `Browse ${this.selectedUrl} and search for the cheapest ${this.searchItem}`;
        // await this.$nextTick(); // Wait for the DOM update
        // setTimeout(() => this.submitQuery(), 3000); // 3000 milliseconds == 3 seconds
      } else if (this.preset === 'report') {
        if (!this.subject || !this.reportLength || !this.researchNotes || this.researchWebsites.length === 0) return;
         // Append researchNotes to the queryPrompt

        this.queryPrompt = `Research the subject ${this.subject} by browsing ${this.researchUrl}. Write a ${this.reportLength} report.`;
        this.queryPrompt += ` and also search https://www.google.com for more data on ${this.subject}, as well as the Notes: ${this.researchNotes}.`;
        this.researchWebsites.forEach(site => {
          this.queryPrompt += ` Reference: ${site}.`;
        });

        if (this.sortedReferences && this.sortedReferences.length > 0) {
          this.queryPrompt += ' Please include the following references in the report: ';
          this.sortedReferences.forEach((ref) => {
            this.queryPrompt += `${ref.url} - ${ref.importancePercentage}%. `;
    });
  }

  await this.$nextTick(); // Wait for the DOM update
  // setTimeout(() => this.submitQuery(), 3000); // 3000 milliseconds == 3 seconds
}


      if (!this.queryPrompt) return;

      this.dialogueHistory.push(`<strong>User:</strong> ${this.queryPrompt}`);
      new Audio(submitAudio).play();
      // Show loading spinner and "Thinking" text
      this.loading = true;
      this.loadingText = "Thinking...";

      try {
        const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ message: this.queryPrompt }),
        });
        const content = await response.json();
        new Audio(codeCompleteAudio).play();
        this.loading = false;
        this.loadingText = "Executing action to achieve objective: " + content.message;

        this.dialogueHistory.push(`<strong class="neon">${content.message}</strong>`);
        const responseUrl = content.url;

        if (responseUrl) {
          const leftOfCenter = window.innerWidth / 2 - 450;
          window.open(responseUrl, "_blank", `left=${leftOfCenter}`);
          this.lastSavedUrl = responseUrl;
        }

        this.actionSteps = content.actionSteps || []; // Example: ['Step 1', 'Step 2', 'Step 3']
        this.currentActionIndex = 0;
        this.objectivesAchieved = false;

        this.queryPrompt = "";
      } catch (err) {
        console.error(err);
      }
    },
    saveResults() {
      if (this.editingQueryIndex === -1) {
        this.savedQueries.push({
          query: this.queryPrompt,
          results: this.dialogueHistory,
        });
      } else {
        this.$set(this.savedQueries, this.editingQueryIndex, {
          query: this.queryPrompt,
          results: this.dialogueHistory,
        });
        this.editingQueryIndex = -1;
      }
      localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
    },
    resetDialogue() {
    this.queryPrompt = '';
    this.dialogueHistory = [];
    this.actionSteps = [];
    this.currentActionIndex = 0;
    this.objectivesAchieved = false;
  },
  approveAction() {
    // Execute the current action and move to the next recommended action
    this.executeAction(this.actionSteps[this.currentActionIndex]);
    this.nextRecommendedAction();
  },
  nextRecommendedAction() {
      if (this.currentActionIndex < this.actionSteps.length - 1) {
        this.currentActionIndex++;
      } else {
        this.currentActionIndex = 0;
      }
    },
  executeContinuousMode() {
    this.continuousMode = !this.continuousMode; // Toggle continuous mode

    if (this.continuousMode) {
      for (const step of this.actionSteps) {
        this.executeAction(step);
      }

      this.objectivesAchieved = true;
    }
  },
  executeAction(action) {
    // Implement the logic to execute the action, such as interacting with the opened web page
    console.log(`Executing action: ${action}`);
  },
  saveQuery() {
  const newQuery = {
    preset: this.preset,
    searchItem: this.searchItem,
    selectedUrl: this.selectedUrl,
    subject: this.subject,
    reportLength: this.reportLength,
    researchUrl: this.researchUrl,
    researchNotes: this.researchNotes,
    // Any other relevant data you wish to save
  };
  if (this.editingQueryIndex === -1) {
        this.savedQueries.push(this.queryPrompt);
      } else {
        this.$set(this.savedQueries, this.editingQueryIndex, this.queryPrompt);
        this.editingQueryIndex = -1;
      }
      localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
  if (this.editingQueryIndex === -1) {
    this.savedQueries.push(newQuery);
  } else {
    this.$set(this.savedQueries, this.editingQueryIndex, newQuery);
    this.editingQueryIndex = -1;
  }
  localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
},
    updateQuery() {
      if (this.editingQueryIndex !== -1) {
        this.$set(this.savedQueries, this.editingQueryIndex, this.queryPrompt);
        this.editingQueryIndex = -1;
        localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
      }
    },
    editSavedQuery(index) {
      this.queryPrompt = this.savedQueries[index];
      this.editingQueryIndex = index;
      if (this.lastSavedUrl) {
        window.open(this.lastSavedUrl, "_blank");
      }
      this.dialogueHistory.push(`<strong>User:</strong> ${this.queryPrompt}`);
    },
    deleteSavedQuery(index) {
      this.savedQueries.splice(index, 1);
      localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
    },
  },
  computed: {
    sortedReferences() {
      // return [...this.references].sort((a, b) => b.importance - a.importance);
      // or using slice method
      return this.references.slice().sort((a, b) => b.importance - a.importance);
    },
  },
};
</script>
